










































import Vue from 'vue'

export default Vue.extend({
  name: 'Score',
  props: {
    score: {
      type: Number,
      default: 0,
      required: true
    },
    type: {
      type: String,
      default: 'global'
    },
    showMoreInformation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    source () {
      return require(`@/assets/images/scores/${this.type}/score-${this.score}.png`)
    },
    confidenceLevel () {
      if (this.score <= 3) {
        return this.$t('baja')
      }

      if (this.score <= 6) {
        return this.$t('media')
      }

      return this.$t('alta')
    }
  },
  methods: {
    emitShowMoreInformation () {
      this.$emit('show-more-information', true)
    }
  }
})
